module.exports = __webpack_public_path__ + "static/media/Sr_tool_logo_dark_text_2.73f22261.svg";